<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-arrow-right"
    viewBox="0 0 32 32"
  >
    <path
      fill="#000000"
      d="M8.5,5.015L10.117,3.5L23.5,16L10.117,28.5L8.5,26.991L20.258,16L8.5,5.015z"
    />
  </svg>
</template>
<script>
export default {};
</script>
